module.exports = __webpack_public_path__ + "media/images/creator/monitor/badge@3x-3200e68a1baad86d30b258b6afc7fd15.png";